export type OptionsList = {
    label : string;
    value : string;
}

export function formatOption(lst:any[], withNone: boolean=false, sortOrder=true) {

    let options:{"label" : string, "value": string}[] = [];
    lst.forEach((l) => {
        options.push({
            "label" : String(l),
            "value" : String(l)
        })
    })

    
    if (sortOrder) {
        options = options.sort((first, second) => {

            if (first.value > second.value) {return 1;}
            if (first.value < second.value) {return -1;}
            return 0;
        })
    }
    

    if (withNone) {
        options.push({
        "label" : "None",
        "value" : "None"
    })}

    return options;

}